/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import { Injectable            } from '@angular/core';

import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor              } from '@angular/common/http';

import { Observable            } from 'rxjs';

import { User                  } from '@/models/user';
import { AuthenticationService } from '@/services/authentication.service';

@Injectable()

/**
 *
 * @class AuthHeaderStamp
 *
 * @brief this helper adds the OAuth Authorization header to all outgoing HTTP requests, using the
 * access token of the logged-in user...if there is one.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class AuthHeaderStamp implements HttpInterceptor {

  constructor(private auth: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    /* add authorization header with jwt token if available */

    const currentUser: User = this.auth.userOfSession;

    if (currentUser && currentUser.token) {

      request = request.clone({

        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`
        }

      });
    }

    return next.handle(request);
  }
}
